import React from 'react';
import busiTypeKey from '../../_util/busiTypeKey';
import { Card, Col, Row, Avatar, Tag, Table, Button } from 'kenshin';
import ServCategoryList from '../../createProcess/changePage/components/ServCategoryList';
import { cardJSONRender } from './util';
/** 表格表头 */
const cloumns = () => {
  const columns = [
    {
      dataIndex: 'userInfo',
      title: '被考核人',
      width: 120,
      fixed: 'left',
      render(userInfo) {
        return userInfo?.value;
      },
    },
    {
      dataIndex: 'osaWeekType',
      title: '信息类别',
      width: 120,
      fixed: 'left',
      render(value) {
        const key = {
          1: '周计划',
          3: 'OSA季度绩效',
        };
        return key[value];
      },
    },
    {
      dataIndex: 'osaName',
      title: '绩效名称',
      width: 150,
    },
    {
      key: 'osaSumRemark',
      title: '评分',
      width: 180,
      render: (row) => {
        if (row.osaWeekType == 1) {
          return <div key={2}>上级评分：{row.osaDirectTotalScore ?? '-'}</div>;
        }
        return [
          <div key={1}>自评：{row.osaSelfTotalScore ?? '-'}</div>,
          <div key={2}>上级评分：{row.osaDirectTotalScore ?? '-'}</div>,
          <div key={3}>业务负责人：{row.osaBusiTotalScore ?? '-'}</div>,
        ];
      },
    },
    {
      dataIndex: 'osaGrade',
      title: '评级',
      width: 120,
      render: (val) => val ?? '-',
    },
    {
      dataIndex: 'curnNode',
      title: '当前环节',
      width: 180,
    },
  ];
  return columns;
};
/** 搜索数据 */
const searchCloumns = ({}) => {
  const searchCloumns = [];
  return searchCloumns;
};

/** 编辑数据 */
const formCloumns = ({}) => [];

/** 首次保存 */
const firstSave = (values, { process, getAfterStr }) => {};

/** 再次保存 */
const reSave = (values, { process, getAfterStr }) => {};

/** 创建后 */
const created = ({ dispatch }) => {};

/** 预览card */
const getCard = (afterData) => {
  if (Object.keys(afterData).length == 0) {
    return null;
  }
  let data = afterData?.newData || afterData;

  const cloumns = [
    {
      label: '项目名称',
      value: 'projectName',
    },
    {
      label: '合同编号',
      value: 'contractIdStr',
    },
    {
      label: '项目周期',
      value: 'projectTime',
      render: (time) => [data.projectBeginTime, ' ~ ', data.projectEndTime],
    },
    {
      label: '项目经理',
      value: 'projectManagerStr',
    },
    {
      label: '项目金额',
      value: 'projectAmount',
    },
    {
      label: '项目描述',
      span: 20,
      value: 'projectDescribtion',
    },
    {
      label: '工作包清单',
      value: 'dbServCatgList',
      span: 20,
      render: () => <ServCategoryList value={data.dbServCatgList} disabled />,
    },
  ];
  return (
    <Card className="process-card-box">{cardJSONRender(cloumns, data)}</Card>
  );
};

/** 确定 */
const onSubmit = ({
  dispatch,
  curData,
  setCreateBtnLoading,
  saveCacheData,
}) => {
  return (params) => {
    dispatch({
      type: 'project/getProjectDetail',
      payload: {
        projectId: curData.current.projectId,
      },
    }).then((res) => {
      saveCacheData(params, {
        ...res,
        proServCatgDiscTotalAmount: curData.current.proServCatgDiscTotalAmount,
      });
      setCreateBtnLoading(false);
    });
  };
};

export default {
  key: busiTypeKey.PROJECT,
  chooseId: 'projectId',
  propsName: (data) => data['projectName'],
  cloumns,
  searchCloumns,
  formCloumns,
  firstSave,
  reSave,
  created,
  getCard,
  onSubmit,
};
